// extracted by mini-css-extract-plugin
export default {"searchPageStack":"SearchPage_searchPageStack__DUHI6"};